<div class="skeleton" aria-busy="true" aria-label="Loading pipeline health">
  <div class="skeleton__cards">
    <ngx-skeleton-loader
      class="skeleton__card"
      *ngFor="let card of cards; trackBy: trackByIndex"
      count="1"
      appearance="line"
      [theme]="cardTheme"
    ></ngx-skeleton-loader>
  </div>
  <ngx-skeleton-loader class="skeleton__funnel" count="1" appearance="line" [theme]="funnelTheme"></ngx-skeleton-loader>
</div>
